module.exports = __webpack_public_path__ + "static/trafik-edinme-284fee9840a82c1310a8103d8cafbc72.jpg";